'use strict';

import template from './join_option_button.html';

const controller = [
  '$q',
  '$element',
  'social',

  function ($q, $element, social) {
    this.fetchScripts = function () {
      this.isLoadingScript = true;

      social.fetchScripts(this.options.name)
        .finally(function () {
          delete this.isLoadingScript;
        }.bind(this));
    };

    if (this.options.social) {
      this.fetchScripts();
    }
  }
];
const saJoinOptionButton = [
  function () {
    return {
      template: template,
      replace: true,
      scope: {
        options: '='
      },
      bindToController: true,
      controllerAs: 'ctrl',
      controller: controller
    };
  }
];

export default saJoinOptionButton;



// WEBPACK FOOTER //
// ./app/src/modules/join/join_option_button.component.js